import { ReactNode } from "react";
import Image from "@Components/Image";
import LinkComponent from "@Components/Link";
import MetaHead from "@Components/meta-head";
import { titleTail } from "@Constants/meta";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import classes from "./RecipeKioskLayout.module.scss";

interface IRecipeKioskLayout {
  pageModel?: any;
  mainClass?: string;
  pageTitle?: string;
  children?: ReactNode;
  pageDescription?: string;
  rightHeaderContent?: ReactNode;
  headTitleTail?: string; // pass empty string to remove the titleTail from the <title> tag
}

export function RecipeKioskLayout({
  children,
  pageModel,
  pageTitle = "",
  rightHeaderContent,
  pageDescription = "",
  headTitleTail = titleTail,
  mainClass = "layout__main",
}: IRecipeKioskLayout) {
  const { languageCode } = useAppSelector(localeSelector);
  const siteLogoURL = pageModel?.siteGlobal?.header?.siteLogo?.url ?? "";
  const copyRightsContent =
    pageModel?.siteGlobal?.footer?.copyRightsContent ?? "";

  return (
    <>
      <MetaHead
        headTitle={pageTitle}
        headTitleTail={headTitleTail}
        headDescription={pageDescription}
      />

      <div className={classes.wrapper}>
        <header className={classes.header} id="site-header">
          <LinkComponent
            href={`/${languageCode}/blogs/recipes/?viewMode=${KIOSK_VIEW_MODE_QUERY}`}
          >
            <a className={classes.logo}>
              <Image
                alt="Logo"
                layout="fill"
                src={`${siteLogoURL}?fm=webp&w=1920&h=1080`}
                objectFit="contain"
                className={classes.logo}
              />
            </a>
          </LinkComponent>

          {rightHeaderContent}
        </header>

        <main className={mainClass}>{children}</main>

        <footer className={classes.footer}>
          <section className={classes.copyright}>{copyRightsContent}</section>
        </footer>
      </div>
    </>
  );
}

export default RecipeKioskLayout;
